export default (camelCaseWord) => {

    return camelCaseWord.replace(/([A-Z])/g, ' $1')
    // uppercase the first character
    .replace(/^./, function(str){ return str.toUpperCase(); })
}


// WEBPACK FOOTER //
// ./src/helpers/camelCaseToNormal.js